import React, { useState } from 'react';
import Truncate from 'react-truncate';
import { Link } from '@material-ui/core';

interface TruncatedContentProps {
  truncate?: boolean;
  onTruncate?: () => void;
  onExpand?: () => void;
}

const TruncatedContent = ({
  children,
  truncate,
  onTruncate,
  onExpand,
}: React.PropsWithChildren<TruncatedContentProps>) => {
  const [truncated, setTruncated] = useState(truncate);

  const handleTruncate = () => {
    setTruncated(true);
    if (onTruncate) {
      onTruncate();
    }
  };

  const handleExpand = () => {
    setTruncated(false);
    if (onExpand) {
      onExpand();
    }
  };

  return (
    <>
      {!truncated && (
        <>
          {children}
          <Link className="cursor-pointer" onClick={handleTruncate}>
            <span>
              <br /> Show Less
            </span>
          </Link>
        </>
      )}
      {truncated && (
        <Truncate
          lines={1}
          ellipsis={
            <Link className="cursor-pointer" onClick={handleExpand}>
              <span>
                <br /> Show more...
              </span>
            </Link>
          }
        >
          {children}
        </Truncate>
      )}
    </>
  );
};

export default TruncatedContent;
